// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"a687bcef","204":"d0ffd5f9","994":"a687bcef"}[chunkId] + ".css";
};